import React from 'react';
const stats = [{
  value: '6',
  label: 'Specialized Clinical Volumes'
}, {
  value: '5',
  label: 'Exclusive Professional Bonuses'
}, {
  value: '100%',
  label: 'Digital Educational Resources'
}];
const stages = ['Analyze', 'Design', 'Validate', 'Communicate'];
export function StatsBand() {
  return <section className="w-full bg-gold-400 px-4 py-10 text-navy-950" aria-labelledby="stats-heading" data-id="element-268" data-mp="3258nv4swxbh2">
      <div className="mx-auto max-w-5xl" data-id="element-269" data-mp="2o57o5sodwa36">
        <h2 id="stats-heading" className="text-center font-display text-lg font-black leading-snug sm:text-2xl" data-id="element-270" data-mp="2o8c1pgnqoi6i">
          Designed for dental professionals who want more confident smile planning
        </h2>
        <div className="mt-7 rounded-2xl bg-navy-950 p-5 text-center text-white sm:p-6" data-id="element-271" data-mp="2f7xegbr7st0d">
          <p className="text-xs font-bold uppercase tracking-widest text-gold-300" data-id="element-272" data-mp="2j98upqo781vw">4 Core Planning Stages</p>
          <ol className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4" data-id="element-273" data-mp="dcd901vowuqc">
            {stages.map((s, i) => <li key={s} className="rounded-xl bg-navy-800 px-2 py-3 font-display text-base font-extrabold sm:text-lg" data-id="element-274" data-mp="qzah70gdlavc" data-mpi={i}>
                <span className="mr-1 text-gold-400" data-id="element-275" data-mp="m0qsisaedkza">{i + 1}.</span>
                {s}
              </li>)}
          </ol>
        </div>
        <dl className="mt-6 grid grid-cols-3 gap-2 text-center" data-id="element-276" data-mp="10obv8l3d1i6o">
          {stats.map(s => <div key={s.label} data-id="element-277" data-mp="vqsijpmb9dgu">
              <dt className="sr-only" data-id="element-278" data-mp="80g03ktfvyc0">{s.label}</dt>
              <dd className="font-display text-3xl font-black sm:text-5xl" data-id="element-279" data-mp="80y81epgs0zr">{s.value}</dd>
              <dd className="mt-1 text-[11px] font-bold leading-tight sm:text-sm" data-id="element-280" data-mp="32my73z65qhj">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}